import React, { useContext, useState, useEffect } from "react"
import { StateContext } from "../../StateProvider"
import { window } from "browser-monads"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Styles
import "./Fahrgeschaefte.scss"

// IMG
import arrowDown from "../../images/card_icons/arrow-down.svg"
import arrowUp from "../../images/card_icons/arrow-up.svg"

// Component
import Card from "./Card/Card"

toast.configure()
const Fahrgeschaefte = () => {
  const [state] = useContext(StateContext)
  const [more, setMore] = useState(false)

  const size = useWindowSize()

  if (state === null) return null

  const sortAttractions = () => {
    if (size.width <= 1020) {
      return 3
    } else {
      return 4
    }
  }

  const notify = () => {
    toast("Ausgewählt! 🥳", {
      position: "top-right",
      autoClose: 1500,
      hideProgressBar: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    })
  }

  return (
    <>
      <section
        id="fahrgeschaefte"
        className="fahrgeschaefte-container my-container"
      >
        <h2 className="headline">Fahrgeschäfte</h2>
        <div className="card-container">
          {more
            ? state.map(item => (
                <Card
                  key={item.id}
                  title={item.title}
                  image={item.img}
                  currentState={item.state}
                  id={item.id}
                  slug={item.slug}
                  notify={notify}
                />
              ))
            : state
                .slice(0, `${sortAttractions()}`)
                .map(item => (
                  <Card
                    key={item.id}
                    title={item.title}
                    image={item.img}
                    currentState={item.state}
                    id={item.id}
                    slug={item.slug}
                    notify={notify}
                  />
                ))}
        </div>
        <div className="more-btn" onClick={() => setMore(!more)}>
          <p>{more ? "Weniger" : "Mehr"}</p>
          <span>
            {more ? (
              <img src={arrowUp} alt="arrow-up" />
            ) : (
              <img src={arrowDown} alt="arrow-down" />
            )}
          </span>
        </div>
        <ToastContainer />
      </section>
    </>
  )
}

// Hook
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowSize
}

export default Fahrgeschaefte
